/**
 * RegistrationObjectUtil
 * incharge of building registration objects
 * Author: Oded Sagir
 * @param  Object require -for adding dependencies
 * @return Object         -Class Object
 */
define(function(require) {
    'use strict';

    var LE = require('app');
    var CONST = require('const');
    var Logger = require("logger");
    var Loader = require("ui/loader/Loader");
    var LEConfig = require("assets/config/le-env-conf");


    // UTILS
    var Storage =                 require("assets/js/storage");
    var RegistrationStorageUtil = require("registration-utils/RegistrationStorageUtil");



    var RegistrationObjectUtil = {};
    LE.module("LERegistration", function (LERegistration, LE, Backbone, Marionette, $, _) {
        RegistrationObjectUtil = {
            ENUM_MODE: {
                SIGNUP :            "signUp",
                CREATE_ACCOUNT :    "createAccount",
                BUY_NOW :           "buyNow",
                CHANGE_PLAN :       "changePlan"
            },
            /**
             * a shared function used to construct the info passed on to the route
             * @param  {string} mode ENUM_MODE
             * @return {object}      a hash of info key values
             */
            urlParamsToJSON: function (mode) {
                var extra, urlParamsJSON = {
                    language:                   _setLanguage(),
                    planName:                   _getPlanName(mode === this.ENUM_MODE.SIGNUP),
                    currency:                   _getCurrency(mode === this.ENUM_MODE.CREATE_ACCOUNT),
                    roiaValue:                  _getURLParameter("roia_c")
                };

                if (mode === this.ENUM_MODE.CREATE_ACCOUNT){
                    extra = {
                        tier:                   _setTier(),
                        frequency:              _setFrequency(),
                        automationSecret:       _getAutomationSecret(),
                        token:                  _getURLParameter("key"),
                        flow:                   _getFlow()

                    };
                } else {
                    extra = {
                        campaignSearchKeywords: _getCampaignSearchKeywords(),
                        campaignSource:         _getCampaignSource(),
                        campaignReferrer:       _getCampaignReferrer(),
                        campaignId:             _getCampaignId(),
                        clickId:                _getClickId(),
                        affiliateId:            _getAffiliateId()
                    };
                    if (mode === this.ENUM_MODE.BUY_NOW){
                        extra.source =          _getSource();
                    }
                }
                $.extend(urlParamsJSON, extra); //merge extra onto base urlParamsJSON

                return urlParamsJSON;
            },
            /**
             * creates a n object to be used to construct a RegistrationVerificationModel
             * @param  {[type]} args [description]
             * @return {[type]}      [description]
             */
            buildRegistrationVerficationObject: function (args) {
                var flowQueryParametersText =                                                                     ''  +
                    (args.currency ?                "&crncy=" + args.currency                                   : '') +
                    (args.language ?                "&lang=" + args.language                                    : '') +
                    (args.planName ?                "&planName=" + args.planName                                : '') +
                    (args.campaignSearchKeywords ?  "&campaignSearchKeywords=" + args.campaignSearchKeywords    : '') +
                    (args.campaignSource ?          "&campaignSource=" + args.campaignSource                    : '') +
                    (args.campaignReferrer ?        "&campaignReferrer=" + args.campaignReferrer                : '') +
                    (args.campaignId ?              "&campaignId=" + args.campaignId                            : '');

                 return {
                    "emailLanguage":            args.language,
                    "flowQueryParameters":      flowQueryParametersText,
                    "campaignSearchKeywords":   args.campaignSearchKeywords,
                    "campaignSource":           args.campaignSource,
                    "campaignReferrer":         args.campaignReferrer,
                    "campaignId":               args.campaignId,
                    "roiaValue":                args.roiaValue
                };
            },

            buildAccountModelAttributes: function (urlParamsJSON) {
                var accountModelObject= {
                    "language":     urlParamsJSON.language,
                    "emailToken":   urlParamsJSON.token,
                    "ratePlanName": urlParamsJSON.planName,
                    "productName":  RegistrationStorageUtil.CONSTANT.DEFAULT_PRODUCT_NAME,
                    "flow":         urlParamsJSON.flow,
                    "currency":     urlParamsJSON.currency,
                    "password":     ""
                };

                try {
                    var impactRadiusData = RegistrationStorageUtil.getDataFromStorage(RegistrationStorageUtil.CONSTANT.IMPACT_RADIUS_DATA);
                    if (impactRadiusData){
                        accountModelObject[RegistrationStorageUtil.CONSTANT.AFFILIATE_ID]=    impactRadiusData.affiliateId;
                        accountModelObject[RegistrationStorageUtil.CONSTANT.CLICK_ID]=        impactRadiusData.clickId;
                    }
                } catch (ex){
                    LERegistration.logger.info("exception", "RegistrationObjectUtil:buildAccountModelAttributes", ex);
                }
                return accountModelObject;
            }

        };


        /**
         * PRIVATE FUNCTIONS
         * only available inside the closure
         */

        function _getURLParameter(name) {
            return LE.getQueryStringParameterValue(name, "");
        }

        function _setLanguage() {
            var language = _getURLParameter("lang");
            if (language === "" || !_.contains(_.values(CONST.LANGUAGE),language)){
                if(LE.sessionManager && LE.sessionManager.isAuthenticated() && LE.siteSettings && LE.siteSettings.languageSettings) {
                    language = LE.siteSettings.languageSettings.getAccountLocale();
                }
            }
            language = language || CONST.LANGUAGE['en-US'];
            return language;
        }

        function _getFlow() {
            var flow = _getURLParameter("flow");
            if (flow === "") {
                var defaultFlow= "SBTrial";
                flow = defaultFlow;
            }
            return flow;
        }

        function _setTier() {
            var tier = _getURLParameter("tier");
            if (tier === "") {
                tier = "30";
            }
            return tier;
        }

        function _setFrequency() {
            var frequency = _getURLParameter("frequency");
            if (frequency === "") {
                frequency = "Annual";
            }
            return frequency;
        }

        function _getOrigin() {
            var origin = _getURLParameter("origin");
            if (origin === "") {
                origin = "LivePerson";
            }
            return origin;
        }

        //new
        function _getAffiliateId() {
            var affiliateId = _getURLParameter("affiliateId");
            return affiliateId;
        }

        function _getClickId() {
            var clickId = _getURLParameter("clickId");
            return clickId;
        }

        function _getSource() {
            var source = _getURLParameter("source");
            if (source === "") {
                source = "Self Registration";
            }
            return source;
        }

        function _getPlanName(isTrialFlow) {
            var planName = _getURLParameter("planName");
            if (isTrialFlow && planName === "") {
                planName = encodeURIComponent("30 / Annual");
            }
            return planName;
        }

        function _getCurrency(isShortHand) {
            var currency = _getURLParameter(isShortHand ? "crncy" : "currency");
            if (currency === "") {
                currency = "USD";
            }
            return currency;
        }

        function _getCampaignSearchKeywords() {
            return _getURLParameter("campaignSearchKeywords");
        }

        function _getCampaignSource() {
            return _getURLParameter("campaignSource");
        }

        function _getCampaignReferrer() {
            return _getURLParameter("campaignReferrer");
        }

        function _getCampaignId() {
            return _getURLParameter("Campaign_ID");
        }

        function _getAutomationSecret() {
            return _getURLParameter("automationSecret");
        }


    });
    return RegistrationObjectUtil;
});
